$('.menu-btn').on('click',function(e){
    e.preventDefault();
    $('#main-nav').toggleClass('opened');
    $(this).toggleClass('clicked');
});


$('#main-nav .menu-item-has-children > a').on('click',function(e){
    
    if($(window).width() < 992){
        e.preventDefault();
        $(this).parent('.menu-item-has-children').siblings('.menu-item-has-children').removeClass('actual');
        $(this).parent('.menu-item-has-children').toggleClass('actual').children('.sub-menu').toggle();
        $('.menu-item-has-children:not(.actual) .sub-menu').hide();
    }
});